import React, { Component,useContext } from "react";
import { useLocation, Route,Routes,useNavigate } from "react-router-dom";
import { AuthContext } from "auth";
import AdminNavbar from "components/Navbars/AdminNavbar";
import Footer from "components/Footer/Footer";
import Sidebar from "components/Sidebar/Sidebar";
import routes from "routes.jsx";
import sidebarImage from "assets/img/2.jpg";
import ListarUsuariosSistema from "views/ListarUsuariosSistema";
import EditarUsuarioSistema from "views/EditarUsuarioSistema";
import CrearUsuarioSistema from "views/CrearUsuarioSistema";
import ActualizarContrasena from "views/ActualizarContrasena";
import Consultantes from "views/ListarConsultantes";
import FichaUsuarioConsultante from "views/FichaUsuarioConsultante";
import IngresarUsuarioConsultante from "views/IngresarUsuarioConsultante"
import EditarSesion from "views/EditarSesion"
import Actividades from "views/Actividades";
import EditarActividad from "views/EditarActividad";
import EditarActividadFecha from "views/EditarActividadFecha";
import Proyectos from "views/Proyectos";
import EditarProyecto from "views/EditarProyecto";
import AgendaCompartida from "views/AgendaCompartida";
import ListaMaestra from "views/ListaMaestra";
import RegistroAsistencia from "views/RegistroAsistencia";
import Asistencia from "views/Asistencia";
import ConsultantesHistorico from "views/ListarConsultantesHistorico";
import EditarParticipacionGrupal from "views/EditarParticipacionGrupal";
import Inicio from "views/Inicio";



function Admin() {
  const [image, setImage] = React.useState(sidebarImage);
  const [color, setColor] = React.useState("black");//React.useState("black");
  const [hasImage, setHasImage] = React.useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  var {user,logout}= useContext(AuthContext)
  const mainPanel = React.useRef(null);
 
  React.useEffect(() => {
    async function adminFuncion(){
      document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainPanel.current.scrollTop = 0;
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      var element = document.getElementById("bodyClick");
      element.parentNode.removeChild(element);
    }
   
    if(localStorage.getItem('user')==null){
      logout();
    }

    if(user.EsContrasenaTemporal==1){
      navigate('/ActualizarContrasena', {
        replace: true
        });

    }

    }
    adminFuncion();
    
  }, [location]);
  return (
    <>
      <div className="wrapper">
        <Sidebar color={color} image={hasImage ? image : ""} routes={routes} />
        <div className="main-panel" ref={mainPanel}>
          <AdminNavbar />
          <div className="content">
        
            <Routes>
            <Route
                path=""
                element={<Inicio usuarioActual={user}/>}
              />
              <Route
                path="ListarUsuariosSistema"
                element={<ListarUsuariosSistema usuarioActual={user}/>}
              />
              <Route
                path="EditarUsuarioSistema/:usuario"
                element={<EditarUsuarioSistema usuarioActual={user}/>}
              />
              <Route
                path="CrearUsuarioSistema"
                element={<CrearUsuarioSistema usuarioActual={user}/>}
              />
              <Route
                path="ActualizarContrasena"
                element={<ActualizarContrasena/>}
              />
               <Route
                path="ListarConsultantes"
                element={<Consultantes usuarioActual={user}/>}
              />
              <Route
                path="FichaUsuarioConsultante/:id"
                element={<FichaUsuarioConsultante usuarioActual={user}/>}
              />
              <Route
                path="IngresarUsuarioConsultante"
                element={<IngresarUsuarioConsultante usuarioActual={user}/>}
              />
               <Route
                path="EditarSesion/:sesionId"
                element={<EditarSesion usuarioActual={user}/>}
              />
              <Route
                path="Actividades"
                element={<Actividades usuarioActual={user}/>}
              />
              <Route
                path="EditarActividad/:actividadId"
                element={<EditarActividad usuarioActual={user}/>}
              />
              <Route
                path="EditarActividadFecha/:actividadFechaId"
                element={<EditarActividadFecha usuarioActual={user}/>}
              />
               <Route
                path="Proyectos"
                element={<Proyectos usuarioActual={user}/>}
              />
               <Route
                path="EditarProyecto/:proyectoId"
                element={<EditarProyecto usuarioActual={user}/>}
              />
             
                <Route
                path="AgendaCompartida/:usuarioAgenda"
                element={<AgendaCompartida usuarioActual={user} usuarioAgenda={user} />}
                />
               <Route
                path={"AgendaCompartida"}
                element={<AgendaCompartida  />}
                />
                <Route
                path={"ListaMaestra"}
                element={<ListaMaestra  />}
                />
                <Route
                path={"Asistencia"}
                element={<Asistencia  />}
                />
                <Route
                path={"RegistroAsistencia"}
                element={<RegistroAsistencia  />}
                />

                <Route
                path="ListarConsultantesHistorico"
                element={<ConsultantesHistorico usuarioActual={user}/>}
                />
               <Route
                path="EditarParticipacionGrupal/:participacionGrupalId"
                element={<EditarParticipacionGrupal usuarioActual={user}/>}
              />
              
           
          
            </Routes>
           
          </div>
        
          <Footer />
        </div>
      </div>
      
    </>
  );
}

export default Admin;
